module.exports = __webpack_public_path__ + "media/images/icons/flags/MS-742cb8bd28a1385abe6f6b8c8a966eda.svg";